<template>
  <div>
    <div>
      <div class="row my-4 mx-1 justify-content-center">
        <v-container v-if="progress" type="image" class="loding">
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </v-container>
        <div v-else class="col-lg-8 col-sm-12 col-md-10 borderPointier">
          <div class="background-white">
            <div class="title">
              <div class="position">
                {{ $t("Types_isolants_thermiques") }} 
              </div>
            </div>
          </div>
          
          <form @submit.prevent="isolation_combles_toitureAdd">
            <div class="center mt-3">
              <b-form-checkbox
                v-model="selected"
                class="mb-3"
                name="checkbox1"
                value="A"
                unchecked-value="B"
              >
                {{ $t("Nécessite_pare-vapeur") }}
              </b-form-checkbox>
            </div>
            <b-form-group
            
              label-for="select-bois"
              class="mt-3"
            >
              <template #label>
    {{ $t('type_isolation') }} <span class="text-danger">*</span>
  </template>
              <b-form-select
                v-model="selectedTypePose"
                :options="options_type_pose"
                id="select-bois"
                class="custom-input"
              >
              </b-form-select>
            </b-form-group>
            <b-form-group
             
              label-for="select-type-appareil"
            >
              <template #label>
    {{ $t('Types_isolants_thermiques') }} <span class="text-danger">*</span>
  </template>
              <b-form-select
                v-model="type_isolant"
                :options="typeAppareilOptions"
                id="select-type-appareil"
                class="custom-input"
              >
              </b-form-select>
            </b-form-group>

            <div class="fieldset mb-2" v-if="type_isolant">
              <div class="legend mb-2">
    {{ type_isolant === 'reflechesson_et_non_reflichessant' ? 'norme reflichessant' : $t('NORM') }} <span class="text-danger">*</span>
              </div>
              <b-form-input
                type="text"
                v-model="norme"
                id="select-norme"
                :placeholder="type_isolant === 'reflechesson_et_non_reflichessant' ? 'norme reflichessant' : $t('NORM')"
                class="form-input custom-placeholder custom-input"
              >
              </b-form-input>
            </div>
            <!-- Deuxième norme si option combinée est sélectionnée -->
            <div class="fieldset mb-2" v-if="type_isolant === 'reflechesson_et_non_reflichessant'">
              <div class="legend mb-2">
    norme non reflichessant <span class="text-danger">*</span>
              </div>
              <b-form-input
                type="text"
                v-model="norme2"
                id="select-norme2"
                placeholder="norme non reflichessant"
                class="form-input custom-placeholder custom-input"
              >
              </b-form-input>
            </div>
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                {{ $t("surface_isolant") }}   <span class="text-danger">*</span> 
              </div>
              <b-form-input
                type="number"
                min="0"
                @paste="
                  (event) =>
                    onPaste(
                      event,
                      'isolation_combles_toitureData.surface_isolant'
                    )
                "
                @keydown="(event) => onKeyDown(event)"
                v-model="isolation_combles_toitureData.surface_isolant"
                :placeholder="$t('surface_isolant')"
                class="form-input custom-placeholder custom-input"
              >
              </b-form-input>
            </div>
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                {{ $t("resistance_thermique") }}   <span class="text-danger">*</span> 
              </div>
              <b-form-input
                type="number"
                min="0"
                @paste="
                  (event) =>
                    onPaste(
                      event,
                      'isolation_combles_toitureData.resistance_thermique'
                    )
                "
                @keydown="(event) => onKeyDown(event)"
                v-model="isolation_combles_toitureData.resistance_thermique"
                :placeholder="$t('resistance_thermique')"
                class="form-input custom-placeholder custom-input"
              >
              </b-form-input>
            </div>
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                {{ $t("epaisseur") }}   <span class="text-danger">*</span> 
              </div>
              <b-form-input
                type="number"
                min="0"
                @paste="
                  (event) =>
                    onPaste(event, 'isolation_combles_toitureData.epaisseur')
                "
                @keydown="(event) => onKeyDown(event)"
                v-model="isolation_combles_toitureData.epaisseur"
                :placeholder="$t('epaisseur')"
                class="form-input custom-placeholder custom-input"
              />
            </div>
            
            <!-- Champs contact sur site -->
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                {{ $t("Contact sur site") || "Contact sur site" }}
              </div>
              <b-form-input
                type="text"
                v-model="contactSurSite"
                :placeholder="$t('Contact sur site') || 'Contact sur site'"
                class="form-input custom-placeholder custom-input"
                @input="updateContactSurSite"
              />
            </div>
            
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                {{ $t("Fonction") || "Fonction" }}
              </div>
              <b-form-input
                type="text"
                v-model="fonctionContact"
                :placeholder="$t('Fonction') || 'Fonction'"
                class="form-input custom-placeholder custom-input"
                @input="updateFonctionContact"
              />
            </div>
            
            <div class="fieldset mb-2">
              <div class="legend mb-2">
                {{ $t("Téléphone") || "Téléphone" }}
              </div>
              <phone
                :tel="telephoneContact"
                @phoneNumber="formatTelephoneContact($event)"
              ></phone>
            </div>
          </form>
        
        </div>
        
      </div>
     
    </div>
  
    <div v-if="!show" class="d-flex justify-content-end mt-4">
      <b-button @click="goToPrevStep" class="button-pre-style m-3">
        {{ $t("PREVIOUS") }}
      </b-button>
      <b-button
        type="submit"
        @click="goToStep"
        class="button-suivant-style m-3"
      >
        {{ $t("NEXT") }}
        <div class="loading ml-2" v-if="isLoading">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
        <div class="loading ml-2" v-if="isLoadingButton">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
      </b-button>
    </div>
    <Snackbar ref="snackbar" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import domain from "@/environment";
import axios from "axios";
import Snackbar from "@/components/ui/errorSnackbar.vue";
import phone from "@/components/ui/phone.vue";
import { handlePaste, preventExceedingLengthFloat } from "@/utils/inputUtils";
export default {
  components: {
    Snackbar,
    phone,
  },
  props: {
    show: {
      type: Boolean,
      default:false,
    },
    title: {
      type: String,
      default: "",
      required: false,
    },
    visibleTabsLength: {
      type: Number,
      required: true,
    },
    isLoadingButton: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCompleted: false,
      errorMessage: "",
      isLoading: false,
      selected: "A",
      selectedTypePose: null,
      isolation_combles_toitureData: null,
      isolation_combles_toiture: false,
      type_isolant: null,
      norme: null,
      norme2: null,
      options_type_pose: [
        { value: "en combles perdu", text: this.$t("en_combles_perdu") },
        {
          value: "en rampant de toitures",
          text: this.$t("en_rampant_de_toitures"),
        },
      ],
      typeAppareilOptions: [
        { value: null, text: this.$t("Sélectionnez_type"), disabled: true },
        { value: "non reflechissant", text: this.$t("non_reflechissant") },
        { value: "reflechissant", text: this.$t("reflechissant") },
        { value: "reflechesson_et_non_reflichessant", text: this.$t("reflechesson et non reflichessant") }, // option combinée

      ],
    };
  },
  created() {
    if (this.getdevisMonoFiche && this.getdevisMonoFiche.data) {
      this.isolation_combles_toitureData =
        this.initializeisolation_combles_toiture();

      if (this.isolation_combles_toitureData.necessite_pare_vapeur === 1) {
        this.selected = "A";
      } else {
        this.selected = "B";
      }
      this.initializeContactFields();
    }
  },
  computed: {
    ...mapState({
      token: (state) => state.token,
    }),
    ...mapGetters(["getdevisMonoFiche"]),
    buttonText() {
      return this.visibleTabsLength <= 1 ? this.$t("NEXT") : this.$t("CONFIRMER");
    },
  },
  watch: {
    getdevisMonoFiche: {
      handler(newDevis) {
        if (newDevis && newDevis.data) {
          // Préserver les valeurs locales existantes
          const currentSurface = this.isolation_combles_toitureData?.surface_isolant;
          const currentEpaisseur = this.isolation_combles_toitureData?.epaisseur;
          const currentResistance = this.isolation_combles_toitureData?.resistance_thermique;
          const currentTypeIsolant = this.type_isolant;
          const currentNorme = this.norme;
          const currentNorme2 = this.norme2;
          const currentTypePose = this.selectedTypePose;
          
          this.isolation_combles_toitureData =
            this.initializeisolation_combles_toiture();
          
          // Restaurer les valeurs locales si elles existent
          if (currentSurface !== undefined && currentSurface !== "") {
            this.isolation_combles_toitureData.surface_isolant = currentSurface;
          }
          if (currentEpaisseur !== undefined && currentEpaisseur !== "") {
            this.isolation_combles_toitureData.epaisseur = currentEpaisseur;
          }
          if (currentResistance !== undefined && currentResistance !== "") {
            this.isolation_combles_toitureData.resistance_thermique = currentResistance;
          }
          if (currentTypeIsolant !== null && currentTypeIsolant !== undefined) {
            this.type_isolant = currentTypeIsolant;
          }
          if (currentNorme !== null && currentNorme !== undefined) {
            this.norme = currentNorme;
          }
          if (currentNorme2 !== null && currentNorme2 !== undefined) {
            this.norme2 = currentNorme2;
          }
          if (currentTypePose !== null && currentTypePose !== undefined) {
            this.selectedTypePose = currentTypePose;
          }
          
          this.isolation_combles_toiture =
            newDevis.data?.devis.isolation_combles_toiture !== null;
          if (!this.type_isolant) {
          this.type_isolant =
            newDevis.data?.devis?.isolation_combles_toiture?.type_isolant ||
            null;
          }
          if (!this.norme) {
          this.norme =
            newDevis.data?.devis?.isolation_combles_toiture?.norme || null;
          }
          if (!this.norme2) {
          this.norme2 =
            newDevis.data?.devis?.isolation_combles_toiture?.norme2 || null;
          }
          this.initializeContactFields();
          if (this.isolation_combles_toiture) {
            this.isCompleted = true;
          }
          if (this.isolation_combles_toiture && this.isolation_combles_toiture.necessite_pare_vapeur === 1) {
            this.selected = "A";
          } else if (this.isolation_combles_toiture && this.isolation_combles_toiture.necessite_pare_vapeur !== 1) {
            this.selected = "B";
          }
        }
      },
      deep: true,
      immediate: true,
      "isolation_combles_toitureData.type_pose": {
        handler(newValue) {
          this.selectedTypePose = newValue
            ? "en combles perdu"
            : "en rampant de toitures";
        },
        immediate: true,
        "isolation_combles_toitureData.necessite_pare_vapeur": {
          handler(newValue) {
            this.selected = newValue === 1 ? "A" : "B";
          },
          immediate: true,
        },
      },
    },
    type_isolant(newVal) {
      if (newVal !== 'reflechesson_et_non_reflichessant') {
        this.norme2 = null;
      }
    },
  },
  methods: {
    ...mapActions(["setDevisMonoFiche"]),

    onKeyDown(event) {
      preventExceedingLengthFloat(event);
    },

    onPaste(event, fieldName) {
      handlePaste.call(this, event, fieldName);
    },
    async postIsolationCombleToiture(payload) {
      try {
        const response = await axios.post(
          domain + `/isolation_combles_toiture`,
          payload,
          {
            headers: {
              Authorization: `Bearer ` + this.token,
            },
          }
        );
        return response.data.data;
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          this.errorMessage = error.response.data.message;
        } else if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          this.errorMessage = error.response.data.errors.join(", ");
        } else {
          this.errorMessage = "Vérifiez vos données.";
        }
        this.$refs.snackbar.showSnackbar(this.errorMessage);
        return null;
      }
    },
    async putIsolationCombleToiture(payload) {
      try {
        const response = await axios.put(
          domain + `/isolation_combles_toiture/${payload.id}`,
          payload,
          {
            headers: {
              Authorization: `Bearer ` + this.token,
            },
          }
        );

        return response.data.data;
      } catch (error) {
        throw new Error("Failed to post isolation combles toiture.");
      }
    },
    initializeisolation_combles_toiture() {
      const isolation_combles_toiture =
        this.getdevisMonoFiche?.data?.devis.isolation_combles_toiture || {};
      this.selectedTypePose = isolation_combles_toiture.type_isolant
        ? "en combles perdu"
        : "en rampant de toitures";

      return {
        id: isolation_combles_toiture.id,
        necessite_pare_vapeur:
          isolation_combles_toiture.necessite_pare_vapeur || 0,
        resistance_thermique:
          isolation_combles_toiture.resistance_thermique || "",
        norme: isolation_combles_toiture.norme || "",
        norme2: isolation_combles_toiture.norme2 || "",
        epaisseur: isolation_combles_toiture.epaisseur || "",
        surface_isolant: isolation_combles_toiture.surface_isolant || "",
        type_isolant: isolation_combles_toiture.type_isolant || "",
      };
    },
    async isolationAdd() {
      if (this.selected === "A") {
        this.isolation_combles_toitureData.necessite_pare_vapeur = 1;
      } else {
        this.isolation_combles_toitureData.necessite_pare_vapeur = 0;
      }
      this.isolation_combles_toitureData.type_isolant = this.type_isolant;
      this.isolation_combles_toitureData.norme = this.norme;
      this.isolation_combles_toitureData.norme2 = this.type_isolant === 'reflechesson_et_non_reflichessant' ? this.norme2 : null;
      this.isolation_combles_toitureData.type_pose = this.selectedTypePose;
      
      // S'assurer que les valeurs numériques sont correctement formatées
      const payload = {
        ...this.isolation_combles_toitureData,
        surface_isolant: this.isolation_combles_toitureData.surface_isolant && this.isolation_combles_toitureData.surface_isolant !== "" 
          ? parseFloat(this.isolation_combles_toitureData.surface_isolant) 
          : null,
        epaisseur: this.isolation_combles_toitureData.epaisseur && this.isolation_combles_toitureData.epaisseur !== "" 
          ? parseFloat(this.isolation_combles_toitureData.epaisseur) 
          : null,
        resistance_thermique: this.isolation_combles_toitureData.resistance_thermique && this.isolation_combles_toitureData.resistance_thermique !== "" 
          ? parseFloat(this.isolation_combles_toitureData.resistance_thermique) 
          : null,
      };
      
      const response = await this.postIsolationCombleToiture(payload);

      if (response && response.id !== null) {
        this.getdevisMonoFiche.data.devis.isolation_combles_toiture_id =
          response.id;
        this.getdevisMonoFiche.data.devis.isolation_combles_toiture = {
          id: this.getdevisMonoFiche.data.devis.isolation_combles_toiture_id,
          surface_isolant: this.isolation_combles_toitureData.surface_isolant,
          epaisseur: this.isolation_combles_toitureData.epaisseur,
          resistance_thermique:
            this.isolation_combles_toitureData.resistance_thermique,
          norme: this.isolation_combles_toitureData.norme,
          norme2: this.isolation_combles_toitureData.norme2,
          necessite_pare_vapeur:
            this.isolation_combles_toitureData.necessite_pare_vapeur,
          type_pose: this.isolation_combles_toitureData.type_pose,
          type_isolant: this.isolation_combles_toitureData.type_isolant,
        };
        this.setDevisMonoFiche(this.getdevisMonoFiche);
        return response;
      } else {
        this.isLoading = false;

        return;
      }
    },

    async isolation_combles_toitureAdd() {
      const existingIsolation = this.getdevisMonoFiche?.data?.devis?.isolation_combles_toiture;
      if (this.isolation_combles_toiture && existingIsolation && existingIsolation.id) {
        if (this.selected === "A") {
          this.isolation_combles_toitureData.necessite_pare_vapeur = 1;
        } else {
          this.isolation_combles_toitureData.necessite_pare_vapeur = 0;
        }
        this.isolation_combles_toitureData.type_isolant = this.type_isolant;
        this.isolation_combles_toitureData.norme = this.norme;
        this.isolation_combles_toitureData.norme2 = this.norme2;
        this.isolation_combles_toitureData.type_pose = this.selectedTypePose;
        
        // S'assurer que les valeurs numériques sont correctement formatées
        const chauffe = {
          ...this.isolation_combles_toitureData,
          id: existingIsolation.id,
          surface_isolant: this.isolation_combles_toitureData.surface_isolant && this.isolation_combles_toitureData.surface_isolant !== "" 
            ? parseFloat(this.isolation_combles_toitureData.surface_isolant) 
            : null,
          epaisseur: this.isolation_combles_toitureData.epaisseur && this.isolation_combles_toitureData.epaisseur !== "" 
            ? parseFloat(this.isolation_combles_toitureData.epaisseur) 
            : null,
          resistance_thermique: this.isolation_combles_toitureData.resistance_thermique && this.isolation_combles_toitureData.resistance_thermique !== "" 
            ? parseFloat(this.isolation_combles_toitureData.resistance_thermique) 
            : null,
        };

        const reponse = await this.putIsolationCombleToiture(chauffe);
        this.getdevisMonoFiche.data.devis.isolation_combles_toiture = {
          id: existingIsolation.id,
          surface_isolant: this.isolation_combles_toitureData.surface_isolant,
          resistance_thermique:
            this.isolation_combles_toitureData.resistance_thermique,
          epaisseur: this.isolation_combles_toitureData.epaisseur,
          norme: this.isolation_combles_toitureData.norme,
          norme2: this.isolation_combles_toitureData.norme2,
          necessite_pare_vapeur:
            this.isolation_combles_toitureData.necessite_pare_vapeur,
          type_pose: this.isolation_combles_toitureData.type_pose,
          type_isolant: this.isolation_combles_toitureData.type_isolant,
        };

        this.setDevisMonoFiche(this.getdevisMonoFiche);
        return reponse;
      }
      await this.isolationAdd();
    },
    async goToStep() {
      this.isLoading = true;
      this.isCompleted = false;
      if (this.isolation_combles_toitureData.surface_isolant == "") {
        this.isLoading = false;
        this.isCompleted = false;
        this.$refs.snackbar.showSnackbar("Tous_obligatoires");
        return;
      }
      
      // Valider que norme2 est obligatoire si option combinée est sélectionnée
      if (this.type_isolant === "reflechesson_et_non_reflichessant" && !this.norme2) {
        this.isLoading = false;
        this.isCompleted = false;
        this.$refs.snackbar.showSnackbar(this.$t('NORM') + " 2 est obligatoire");
        return;
      }

      await this.isolation_combles_toitureAdd();
      if (this.errorMessage !== "") {
        this.isLoading = false;

        return;
      }
   
      
      if(this.visibleTabsLength<=1){
        this.$emit("change",true);
      }
      this.isLoading = false;
      this.isCompleted = true;
    },
    async goToNextStep() {
      this.isLoading = true;
      if (this.isolation_combles_toitureData.surface_isolant == "") {
        this.isLoading = false;
        this.$refs.snackbar.showSnackbar("Tous_obligatoires");
        return;
      }
      
      // Valider que norme2 est obligatoire si option combinée est sélectionnée
      if (this.type_isolant === "reflechesson_et_non_reflichessant" && !this.norme2) {
        this.isLoading = false;
        this.$refs.snackbar.showSnackbar(this.$t('NORM') + " 2 est obligatoire");
        return;
      }

      await this.isolation_combles_toitureAdd();
      if (this.errorMessage !== "") {
        this.isLoading = false;

        return;
      }
      this.isLoading = false;
      this.$emit("changeStep", 5, true);
    },

    goToPrevStep() {
      if(this.visibleTabsLength<=1){
        this.$emit("changePrev",true);
      }else {
        this.$emit("changePrev",false);
      }
      this.$emit("changeStep", 3);
    },
    initializeContactFields() {
      const devis = this.getdevisMonoFiche?.data?.devis;
      this.contactSurSite = devis?.contact_sur_site || null;
      this.fonctionContact = devis?.fonction_contact || null;
      this.telephoneContact = devis?.telephone_contact || null;
    },
    updateContactSurSite() {
      this.getdevisMonoFiche.data.devis.contact_sur_site = this.contactSurSite || null;
      this.setDevisMonoFiche(this.getdevisMonoFiche);
    },
    updateFonctionContact() {
      this.getdevisMonoFiche.data.devis.fonction_contact = this.fonctionContact || null;
      this.setDevisMonoFiche(this.getdevisMonoFiche);
    },
    formatTelephoneContact(event) {
      if (event && event.number && event.country) {
        this.telephoneContact = {
          phone_number: event.number,
          phone_iso_code: event.country.iso2,
          formated_phone: event.formatted || null,
        };
        this.getdevisMonoFiche.data.devis.telephone_contact = this.telephoneContact;
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      } else if (!event || !event.number) {
        this.telephoneContact = null;
        this.getdevisMonoFiche.data.devis.telephone_contact = null;
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      }
    },
  },
};
</script>
<style scoped>
.custom-placeholder::placeholder {
  font-size: 13px;
}
.form-input {
  font-size: 13px;
  height: 41.1px !important;
}
.borderPointier {
  border: 2px dashed #24316d;
  position: relative;
}
.input-style {
  margin-bottom: 1rem;
  border-radius: 4px;
  border: 1px solid #eaebec;
  padding: 0.5rem 0.75rem;
  background-color: #fff;
}

.background-white {
  display: inline-block;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  position: absolute;
  top: -1rem;
  left: 0;
  right: 0;
  z-index: 1;
  text-align: center;
}
.title {
  color: #24316d;
  position: relative;
  z-index: 2;
  margin: 0;
}

.position {
  background-color: white;
  display: inline-block;
  padding: 0.05rem 2rem;
}
.custom-input {
  box-shadow: none;
}
.small-spinner .spinner-border {
  width: 1rem;
  height: 1rem;
}
</style>
